import { EDIT_LISTING_SEO_TITLE,
         CLOSE_LISTING_SEO_TITLE,
         PENDING_SUBMIT_LISTING_SEO_TITLE,
         COMPLETE_SUBMIT_LISTING_SEO_TITLE,
         FAILED_SUBMIT_LISTING_SEO_TITLE
    } from "./mlTypes"


const initialState = {
    pendingsubmit: false,
    failedsubmit: false,
    completesubmit: false,
    propertyseotitleediting: false
}


const mlListingSEOTitle = (state = initialState, action) => {
    switch (action.type) {
        case EDIT_LISTING_SEO_TITLE: return {
            ...state,
            pendingsubmit: false,
            failedsubmit: false,
            completesubmit: false,
            propertyseotitleediting: true
        }

        case CLOSE_LISTING_SEO_TITLE: return {
            ...state,
            pendingsubmit: false,
            failedsubmit: false,
            completesubmit: false,
            propertyseotitleediting: false
        }

        case PENDING_SUBMIT_LISTING_SEO_TITLE: return {
            ...state,
            pendingsubmit: true,
            failedsubmit: false,
            completesubmit: false
        }

        case COMPLETE_SUBMIT_LISTING_SEO_TITLE: return {
            ...state,
            pendingsubmit: false,
            failedsubmit: false,
            completesubmit: true
        }
        
        case FAILED_SUBMIT_LISTING_SEO_TITLE: return {
            ...state,
            pendingsubmit: false,
            failedsubmit: true,
            completesubmit: true
        }
    
        default: return state
    }
}

export default mlListingSEOTitle